import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, funcionalidade } = obj
  const response = await http[verb]('/funcionalidade', funcionalidade)

  if (response !== null) {
    funcionalidade.id = response.data.data.id
    update(context, { ...funcionalidade })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/funcionalidade/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/funcionalidade')
  if (response !== null) {
    const funcionalidades = response.data
    commit('SET_LIST', funcionalidades)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { funcionalidade: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/funcionalidade/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/admin/funcionalidades/store/actions.js